interface PlayersIconProps {
  className?: string;
}

export const PlayersIcon = ({ className }: PlayersIconProps) => (
  <svg className={className} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2386_6123)">
      <path d="M0 14.4444V17.1111C0 17.602 0.407014 18 0.909091 18H13.6364C14.1384 18 14.5455 17.602 14.5455 17.1111V14.4444C14.5455 12.4808 12.9174 10.8889 10.9091 10.8889H3.63636C1.62806 10.8889 0 12.4808 0 14.4444Z" fill="currentColor"/>
      <path d="M16.3491 17.3883C16.3169 17.6934 16.5375 18 16.8512 18H19.0909C19.593 18 20 17.602 20 17.1111V14.4444C20 12.4808 18.3719 10.8889 16.3636 10.8889H15.4832C15.2867 10.8889 15.1789 11.1198 15.2958 11.2741C15.9668 12.1604 16.3636 13.2571 16.3636 14.4444V17.1111C16.3636 17.2047 16.3587 17.2972 16.3491 17.3883Z" fill="currentColor"/>
      <path d="M10.9091 5.55556C10.9091 7.51923 9.28103 9.11111 7.27273 9.11111C5.26442 9.11111 3.63636 7.51923 3.63636 5.55556C3.63636 3.59188 5.26442 2 7.27273 2C9.28103 2 10.9091 3.59188 10.9091 5.55556Z" fill="currentColor"/>
      <path d="M12.1371 9.06452C11.8273 9.01508 11.7217 8.65713 11.8891 8.39759C12.4201 7.57484 12.7273 6.60028 12.7273 5.55556C12.7273 4.51083 12.4201 3.53627 11.8891 2.71352C11.7217 2.45398 11.8273 2.09603 12.1371 2.0466C12.3292 2.01594 12.5263 2 12.7273 2C14.7356 2 16.3636 3.59188 16.3636 5.55556C16.3636 7.51923 14.7356 9.11111 12.7273 9.11111C12.5263 9.11111 12.3292 9.09517 12.1371 9.06452Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_2386_6123">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
